export type GalleryScrollType = 'arrows' | 'image';
export type GalleryScrollDirection = 'forward' | 'backward';

type SwiperState = {
  activeIndex: number;
  previousIndex: number;
};

export type GalleryScrollEvent = {
  scroll_type: GalleryScrollType;
  scroll_direction: GalleryScrollDirection;
};

/**
 * Derives the gallery_scroll event payload for a Swiper slide change.
 *
 * scroll_type:
 *   - 'image'  → user clicked a thumbnail in the open gallery's thumb strip
 *   - 'arrows' → everything else (chevron arrows, swipe, keyboard)
 *
 * scroll_direction is derived from the swiper's internal index delta, which
 * is monotonic across loop wraps (loop duplicates handle the boundary).
 */
export const computeGalleryScrollEvent = (
  swiper: SwiperState,
  thumbClicked: boolean,
): GalleryScrollEvent => ({
  scroll_type: thumbClicked ? 'image' : 'arrows',
  scroll_direction:
    swiper.activeIndex >= swiper.previousIndex ? 'forward' : 'backward',
});
